<div class="field-dialog">
  <!-- TAB HEADER START -->
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title">
      {{ 'USERS.DIALOG.TAB_GROUPS.LINKED.ADD' | translate }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
  <!-- TAB HEADER END -->

  <div class="field-dialog__content">
    <form
      #form
      fxLayout="column"
      autocomplete="off"
      class="field-dialog__content__scroll tab-groups"
      fusePerfectScrollbar
    >
      <!-- MAIN FORMS CONTENT START -->
      <div class="main-content">
        <div class="field-outline-form">
          <div class="tab-groups__search-bar">
            <mat-form-field #outlineFieldRef appearance="outline">
              <mat-label>
                {{ 'USERS.DIALOG.TAB_GROUPS.LINK.SEARCH' | translate }}
              </mat-label>

              <mat-icon matPrefix color="primary">search</mat-icon>
              <input
                matInput
                [formControl]="searchGroupsInput"
                (keydown)="$event.stopImmediatePropagation()"
                (focus)="outlineFieldRef.updateOutlineGap()"
                [disabled]="isLoadingGroups"
              />

              <mat-hint>
                {{ 'USERS.DIALOG.TAB_GROUPS.SEARCH_SUGGESTION' | translate }}
              </mat-hint>
            </mat-form-field>
          </div>
        </div>

        <ng-container *ngIf="groupsPagedResult.items">
          <div fxLayout="row" fxLayoutAlign="space-between start">
            <p class="field-dialog__content__scroll__title">
              {{ 'USERS.DIALOG.TAB_GROUPS.LINK.TITLE' | translate }} ({{ groupsPagedResult.totalCount || 0 }})
            </p>

            <mat-checkbox
              class="mr-17"
              data-cy="select-all-checkbox"
              [checked]="isAllSelected"
              [disabled]="isLoadingGroups || !groupsPagedResult.items.length || isAllLinked"
              (change)="selectOrDeselectAllGroups($event.checked)"
            >
            </mat-checkbox>
          </div>

          <div class="tab-groups__body">
            <p *ngIf="!groupsPagedResult.items.length" class="tab-groups__body__not-found-title">
              {{ 'USERS.DIALOG.TAB_GROUPS.LINK.NOT_FOUND' | translate }}
            </p>

            <ng-container *ngIf="groupsPagedResult.items.length">
              <div
                class="card tab-groups__body__card"
                *ngFor="let group of groupsPagedResult.items"
                fxLayout="row"
                fxLayout="space-between center"
                fxLayoutGap="16px"
              >
                <div fxLayout="column" fxLayoutAlign="center start" fxFlex>
                  <p class="tab-groups__body__card__name">
                    {{ group.name }}
                    <span class="tab-groups__body__card__archived" *ngIf="group.archived">
                      {{ 'USERS.DIALOG.TAB_GROUPS.ARCHIVED' | translate }}
                    </span>
                  </p>
                  <p class="tab-groups__body__card__description">
                    {{ group.description || 'USERS.DIALOG.TAB_GROUPS.NO_DESCRIPTION' | translate }}
                  </p>
                </div>

                <div fxLayout="column" fxLayoutAlign="center start">
                  <p *ngIf="isLinkedGroup(group.id)" class="tab-groups__body__card__linked">
                    {{ 'USERS.DIALOG.TAB_GROUPS.LINK.ALREADY_LINKED' | translate }}
                  </p>

                  <mat-checkbox
                    *ngIf="!isLinkedGroup(group.id)"
                    (change)="addOrRemoveGroup(group)"
                    [checked]="isAddedGroup(group.id)"
                    [disabled]="isLoadingGroups"
                  ></mat-checkbox>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="!groupsPagedResult.items">
          <div fxLayout="column" fxLayoutAlign="center center">
            <mat-spinner color="primary" diameter="64" class="mb-24"></mat-spinner>
            {{ 'USERS.DIALOG.TAB_GROUPS.LOADING' | translate }}
          </div>
        </ng-container>
      </div>
      <!-- MAIN FORMS CONTENT END -->

      <!-- PAGINATOR START -->
      <div class="tab-groups__body__paginate" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <p class="tab-groups__body__paginate__title">
          {{
            'USERS.DIALOG.TAB_GROUPS.LINK.PAGINATE'
              | translate
                : {
                    total: groupsPagedResult.totalCount,
                    firstPaginatedGroupIndex: firstPaginatedGroupIndex,
                    lastPaginatedGroupIndex:
                      lastPaginatedGroupIndex <= groupsPagedResult.totalCount
                        ? lastPaginatedGroupIndex
                        : groupsPagedResult.totalCount
                  }
          }}
        </p>

        <button
          mat-stroked-button
          (click)="changePage()"
          [disabled]="!groupsPagedResult?.pageInfo?.hasPreviousPage || isLoadingGroups"
          class="tab-groups__body__paginate__button"
        >
          {{ 'USERS.DIALOG.TAB_GROUPS.PREVIOUS' | translate }}
        </button>

        <button
          mat-stroked-button
          (click)="changePage(true)"
          [disabled]="!groupsPagedResult?.pageInfo?.hasNextPage || isLoadingGroups"
          class="tab-groups__body__paginate__button"
        >
          {{ 'USERS.DIALOG.TAB_GROUPS.NEXT' | translate }}
        </button>
      </div>
      <!-- PAGINATOR END -->
    </form>
  </div>

  <!-- TAB FOOTER START -->
  <div class="field-dialog__footer" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout="row">
    <button
      class="field-background"
      mat-raised-button
      [mat-dialog-close]="groupsToAdd.controls"
      [disabled]="!groupsToAdd.value.length || isLoadingGroups"
    >
      {{ 'USERS.DIALOG.CONTINUE' | translate }}
    </button>

    <button class="field-background--stroked" mat-stroked-button mat-dialog-close>
      {{ 'USERS.DIALOG.BACK' | translate }}
    </button>
  </div>
  <!-- TAB FOOTER END -->
</div>
